import React, { useEffect } from 'react';
import block from 'bem-cn';
// import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Select from 'components/Select/desktop';
import Button from 'components/Button';
import InputDate from 'components/InputDate/desktop';
import CheckBox from 'components/CheckBox';

import DaysFilter from 'features/reports/view/desktop/DaysFilter';
import { searchInItems } from 'features/bonusProgram/data';

import { actions as treeActions } from 'features/tree';

import './FilterBlock.scss';

const b = block('filter-block-create-promotions');

const FilterBlock = ({ model }) => {
  const locale = useSelector(state => state.locale.locale);

  const {
    onClickSearch,
    filters,
    handleSearchInChange,
    statusAll,
    setStatusAll,
    statusActive,
    setStatusActive,
    statusInactive,
    setStatusInactive,
    activeDay,
    onChangeActiveDay,
    date,
    onChangeBeginDate,
    onChangeEndDate,
  } = model;

  const handleFormSubmit = e => {
    e.preventDefault();
    onClickSearch();
  };

  const handleKeyDown = e => {
    if (e?.key === 'Enter') {
      e.preventDefault();
      onClickSearch();
    }
  };

  return (
    <form className={b()} onSubmit={handleFormSubmit} onKeyDown={handleKeyDown} tabIndex={0}>
      <div className={b('header')}>{locale.filter}</div>

      <div className={b('top')}>
        <DaysFilter activeDay={activeDay} setActiveDay={onChangeActiveDay} />
        <div className={b('or')}>{locale.or}</div>
        <div className={b('date')}>
          <div className={b('date-row')}>
            <div className={b('title')}>{locale.dateFrom}</div>
            <div className={b('date-input')}>
              <InputDate showTimeSelect selected={date.beginDate} onChange={onChangeBeginDate} />
            </div>
          </div>
          <div className={b('date-row')}>
            <div className={b('title')}>{locale.dateTo}</div>
            <div className={b('date-input')}>
              <InputDate showTimeSelect selected={date.endDate} onChange={onChangeEndDate} />
            </div>
          </div>
        </div>
      </div>

      <div className={b('bottom')}>
        <div className={b('inputs')}>
          <div className={b('input')}>
            <div className={b('title')}>{locale.language}</div>
            <Select name="lang" items={searchInItems} activeItem={filters.lang} onChange={handleSearchInChange} />
          </div>

          <div className={b('checkboxes')}>
            <div className={b('checkbox')}>
              <CheckBox checked={statusAll} onChange={() => setStatusAll(!statusAll)} name="statusAll" />
              <p className={b('checkbox-title')}>{locale.all}</p>
            </div>
            <div className={b('checkbox')}>
              <CheckBox checked={statusActive} onChange={() => setStatusActive(!statusActive)} name="statusActive" />
              <p className={b('checkbox-title')}>{locale.active}</p>
            </div>
            <div className={b('checkbox')}>
              <CheckBox
                checked={statusInactive}
                onChange={() => setStatusInactive(!statusInactive)}
                name="statusInactive"
              />
              <p className={b('checkbox-title')}>{locale.inactive}</p>
            </div>
            {/* <div className={b('checkbox')}>
              <CheckBox checked={isWithdrawal} onChange={() => setIsWithdrawal(!isWithdrawal)} name="isWithdrawal" />
              <p className={b('checkbox-title')}>{locale.retirement}</p>
            </div> */}
            {/* <div className={b('checkbox')}>
              <CheckBox checked={isBonus} onChange={() => setIsBonus(!isBonus)} name="isBonus" />
              <p className={b('checkbox-title')}>{locale.bonus}</p>
            </div> */}
          </div>
        </div>

        <div className={b('button')}>
          <Button size="low" text={locale.acceptFilter} type="submit" />
        </div>
      </div>
    </form>
  );
};

export default FilterBlock;
